module.exports = __webpack_public_path__ + "img/6337927f0aac7cf9d725aeeb00cb8a83.png";